import styled from "styled-components";
import { typeStyle, units, visuallyHidden } from "@m/alchemy-theme";
export const SelectMessageOption = styled.li.attrs({ "aria-live": "off" }) `
  display: block;
  padding: ${units(2)} ${units(2)};
  position: relative;
  min-height: ${units(4.375)};
  text-align: center;
  ${typeStyle("bodyS")};
  ${({ isVisuallyHidden = false }) => isVisuallyHidden && visuallyHidden()}
`;
